import React from "react";
import { H4 } from "../ui/typography";
import { Link } from "gatsby";
import { container } from "@styles/common-styles.module.css";
import { cn } from "@/utils";
import { footerLink } from "./footer.module.css";
import LogoDark from "../../images/rf-logo-dark.svg";
// import LogoDark from "../../images/rf-web-02.svg";
import Twitter from "../../images/twitter-logo.svg";
import LinkedIn from "../../images/linkedin-logo.svg";
import FaceBook from "../../images/facebook-logo.svg";
import Medium from "../../images/medium.svg";

interface FooterProps extends React.HTMLProps<HTMLDivElement> {}

const Footer: React.FC<FooterProps> = ({ className }) => {
  // const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  //   event.preventDefault();
  // };
  const currentYear = new Date().getFullYear();
  return (
    <footer className={cn("footer mt-8 bg-dark", className)}>
      <div className={`py-12 md:py-20 w-full ${container} px-6 min-[1440px]:px-0`}>
        <div className="md:flex justify-between flex-wrap xl:flex-nowrap inline-block">
          <div className="logo-container md:w-full xl:w-auto xl:text-left text-center ">
            <Link to="#">
              <img
                src={LogoDark}
                alt="Railsfactory logo"
                className="block md:inline-block xl:block"
                style={{ imageRendering: "pixelated" }}
              />
            </Link>
            <div className="flex social-media-icons my-6 md:my-6 xl:mt-12 min-[888px]:justify-center min-[1280px]:justify-start">
              <a target="_blank" href="https://twitter.com/railsfactory">
                <img src={Twitter} alt="twitter logo" style={{ imageRendering: "pixelated" }} />
              </a>
              <a target="_blank" href="https://in.linkedin.com/company/railsfactory">
                <img src={LinkedIn} alt="linkedin logo" style={{ imageRendering: "pixelated" }} />
              </a>
              <a target="_blank" href="https://www.facebook.com/RailsFactory/">
                <img src={FaceBook} alt="facebook logo" style={{ imageRendering: "pixelated" }} />
              </a>
              <a target="_blank" href="https://medium.com/railsfactory">
                <img src={Medium} alt="medium logo" style={{ imageRendering: "pixelated" }} />
              </a>
            </div>
            <div className="md:flex md:justify-center xl:block md:mb-5 xl:mb-0">
              <iframe
                width="200"
                height="200"
                src="https://shareables.clutch.co/share/badges/1067555/129797?utm_source=clutch_award_badge&utm_medium=image_embed"
                title="Top Clutch Ruby On Rails Developer 2024 Award"
              ></iframe>
            </div>
          </div>
          <div className="md:flex  gap-36 min-[1280px]:w-1/2 justify-end">
            <div className="company basis-full md:basis-auto mt-10 md:mt-0 md:min-w-[200px]">
              <H4 className="text text-primary pb-4">Company</H4>
              <div className="company-links flex flex-col gap-[16px]">
                <Link to="/about-us" className={footerLink}>
                  About us
                </Link>
                <Link to="/contact" className={footerLink}>
                  Contact
                </Link>
                <Link to="/blog" className={footerLink}>
                  Blog
                </Link>
                <Link to="/case-studies" className={footerLink}>
                  Case studies
                </Link>
                <Link to="/careers" className={footerLink}>
                  Careers
                </Link>
              </div>
            </div>

            <div className="services basis-full md:basis-auto mt-8 md:mt-0">
              <H4 className="text text-primary pb-4">Services</H4>
              <div className="service-links flex flex-col gap-[16px]">
                <Link to="/services" className={footerLink}>
                  Overview
                </Link>
                <Link to="/hire-ruby-on-rails-developer" className={footerLink}>
                  Hire Ruby on Rails Developer
                </Link>
                <Link to="/custom-application-development-service" className={footerLink}>
                  Custom Software Development
                </Link>
                <Link to="/rails-upgrade-services" className={footerLink}>
                  Rails upgrade Service
                </Link>
                <Link to="/app-modernization-service" className={footerLink}>
                  App Modernization Service
                </Link>
                <Link to="/dedicated-development-team" className={footerLink}>
                  Dedicated Team Service
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between mt-16 flex-wrap md:flex-nowrap">
          <p className="text text-base text-dark-muted order-2 md:order-none mt-4 md:mt-0">
            &copy; 2006 - {currentYear} Railsfactory - A Division of Sedin Technologies
          </p>
          <div className="flex gap-8 footer-links text text-base text-dark-muted md:pl-5">
            <Link to="/sitemap-index.xml">Sitemap</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
